import React from "react";
import "./App.css";
import "leaflet/dist/leaflet.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { StudioAuthProvider } from "./operations/StudioAuthContext";
import { OperationsGate } from "./operations/OperationsGate";
import { OperationsLayout } from "./operations/OperationsLayout";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import Radar from "./pages/Radar";
import Forecast from "./pages/Forecast";
import Watch from "./pages/Watch";
import Alerts from "./pages/Alerts";
import About from "./pages/About";
import Contact from "./pages/Contact";
import ChaserCam from "./pages/ChaserCam";
import Skycams from "./pages/Skycams";
import NotFound from "./pages/NotFound";
import OperationsDashboard from "./pages/OperationsDashboard";
import OperationsRadar from "./pages/OperationsRadar";
import OperationsBuild from "./pages/OperationsBuild";
import OperationsOutput from "./pages/OperationsOutput";

function App() {
  return (
    <div className="App bg-[#01020a]">
      <BrowserRouter>
        <StudioAuthProvider>
          <Routes>
            {/* Public Storm Desk Live Weather site */}
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/radar" element={<Radar />} />
              <Route path="/forecast" element={<Forecast />} />
              <Route path="/watch" element={<Watch />} />
              <Route path="/watch/:id" element={<Watch />} />
              <Route path="/live" element={<Navigate to="/watch" replace />} />
              <Route path="/alerts" element={<Alerts />} />
              <Route path="/skycams" element={<Skycams />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/chase" element={<ChaserCam />} />
              <Route path="*" element={<NotFound />} />
            </Route>

            {/* Private PIN-gated Operations Studio */}
            <Route path="/studio" element={<Navigate to="/ops" replace />} />
            <Route path="/ops" element={<OperationsGate><OperationsLayout /></OperationsGate>}>
              <Route index element={<OperationsDashboard />} />
              <Route path="radar" element={<OperationsRadar />} />
              <Route path="build" element={<OperationsBuild />} />
              <Route path="output" element={<OperationsOutput />} />
              <Route path="studio" element={<Navigate to="/ops/build?tab=scenes" replace />} />
              <Route path="graphics" element={<Navigate to="/ops/build?tab=graphics" replace />} />
              <Route path="sources" element={<Navigate to="/ops/build?tab=sources" replace />} />
              <Route path="audio" element={<Navigate to="/ops/build?tab=audio" replace />} />
              <Route path="broadcast" element={<Navigate to="/ops/output?tab=distribution" replace />} />
              <Route path="system" element={<Navigate to="/ops/output?tab=system" replace />} />
              <Route path="*" element={<Navigate to="/ops" replace />} />
            </Route>
          </Routes>
          <Toaster position="top-right" richColors />
        </StudioAuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
